import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractAutocompleteDataLoader } from 'src/app/components/autocomplete/abstract-autocomplete-data-loader';
import { AutocompleteOption } from 'src/app/components/autocomplete/autocomplete-option';
import { ReturnMessage } from 'src/app/models/return-message';
import { PostFilterFields } from 'src/app/models/shared/post-filter-fields';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class UserAutocompleteDataLoaderService extends AbstractAutocompleteDataLoader {

  constructor(private userService: UserService) {super();}

  load(searchTerm: string): Observable<ReturnMessage<AutocompleteOption[]>> {
    var postFilterFields = <PostFilterFields>{ search: searchTerm };
    return this.userService.autocompleteUsers(postFilterFields)
      .pipe(
          map(response => {
            if (response.success) {
              response.payload = this.fromDictionary(response.payload.users);
            }
            return response;
          })
      );
  }

  loadAll(): Observable<ReturnMessage<AutocompleteOption[]>> {
    var postFilterFields = <PostFilterFields>{ searchAll: true };
    return this.userService.autocompleteUsers(postFilterFields)
      .pipe(
          map(response => {
            if (response.success) {
              response.payload = this.fromDictionary(response.payload.users);
            }
            return response;
          })
      );
  }
}